module.exports = __webpack_public_path__ + "static/media/galerija_2017 (17).5d78eaec.jpg";